import KeyValueListDisplay from '@/components/KeyValueDisplay';
import type { WorkOrderGetByIdResponse } from '@/types/workOrder.types';
import { REPRESENTS, SERVICE_TYPE } from '@/utils/constant';

export const ClientDetailsPeContent = ({ data }: { data: WorkOrderGetByIdResponse | undefined }) => {
  const clientDetails = [
    { label: 'Client’s Contact', value: data?.service?.contact.firstName + ' ' + data?.service?.contact.lastName },
    {
      label: 'Attorney’s Name',
      value: data?.service?.case?.attorney.firstName + ' ' + data?.service?.case?.attorney?.lastName,
    },
    {
      label: 'Represents',
      value: REPRESENTS.find((represent) => represent.value === data?.service?.process?.represents)?.label ?? '',
    },
    {
      label: 'Service Type',
      value: SERVICE_TYPE.find((service) => service.value === data?.service?.type)?.label ?? '',
    },
  ];
  return (
    <div className="flex flex-col gap-4 w-full px-6 py-4">
      <div className="flex flex-col gap-2 w-full text-sm">
        <KeyValueListDisplay data={clientDetails} />
      </div>
      <hr />
      <div className="flex flex-col gap-2">
        <div className="font-semibold text-sm">Instructions</div>
        <div className=" break-words font-medium text-xs">Client Instructions</div>
        <div className="text-[#676767] font-medium text-sm whitespace-pre-wrap">
          {data?.service.client.instructions ?? 'No Instructions'}
        </div>
      </div>
    </div>
  );
};
